import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { FormControl, FormGroup, FormLabel, TextField, MenuItem, Typography, FormHelperText } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    row: {
        minHeight: 45,
        alignItems: 'center'
    },
    filterLabel: {
        alignSelf: 'center',
        width: '27%'
    },
    filterOperator: {
        marginLeft: theme.spacing(1),
        flex: 1
    },
    filterValue: {
        marginLeft: theme.spacing(1),
        flex: 1.5
    },
    secondRowLabel: {
        marginLeft: theme.spacing(1),
        textAlign: 'right'
    }
}))

const Filter = ({
    name,
    operator,
    value,
    secondValue,
    dataType,
    label,
    fullWidth,
    showOperator,
    operators = [],
    onChange,
    component: Component,
    children,
    multiple = false,
    ...others
}) => {
    const classes = useStyles()
    const [operatorState, setOperatorState] = useState(operator)
    const [valueState, setValue] = useState(value || (multiple ? [] : ''))
    const [secondValueState, setSecondValue] = useState(secondValue || (multiple ? [] : ''))

    const handleOperatorChange = event => {
        const newOperator = event.target.value

        setSecondValue('')
        setOperatorState(newOperator)
        if (onChange) onChange({
            name,
            operator: newOperator,
            value: valueState,
            dataType
        })
    }

    const handleValueChange = event => {
        // debugger
        const value = event.target.id !== 'secondValue' ? event.target.value : valueState
        const secondValue = event.target.id === 'secondValue' ? event.target.value : secondValueState

        setValue(value)
        setSecondValue(secondValue)

        if (onChange) onChange({
            name,
            operator: operatorState,
            value: value,
            secondValue: secondValue,
            dataType
        })
    }

    // const handleSecondValueChange = event => {
    //     debugger
    //     const newValue = event.target.value

    //     setSecondValue(newValue)
    //     if (onChange) onChange({
    //         name,
    //         operator: operatorState,
    //         value: valueState,
    //         secondValue: newValue,
    //         dataType
    //     })
    // }

    return (
        <>
            <FormControl
                margin="dense"
                fullWidth
            >
                <FormGroup row className={classes.row}>
                    <FormLabel className={classes.filterLabel} component="label">{label}</FormLabel>
                    {(operators.length > 0) && (
                        <TextField
                            name={name}
                            className={classes.filterOperator}
                            select={true}
                            value={operatorState}
                            onChange={handleOperatorChange}
                        >
                            {operators.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    )}
                    <Component
                        name={name}
                        className={classes.filterValue}
                        multiple={multiple}
                        {...others}
                        value={valueState}
                        onChange={handleValueChange}
                    >
                        {children}
                    </Component>
                    {operatorState == 'btw' && (
                        <>
                            <Typography className={classes.secondRowLabel}>and</Typography>
                            <Component
                                name={'secondValue'}
                                className={classes.filterValue}
                                multiple={multiple}
                                {...others}
                                value={secondValueState}
                                onChange={handleValueChange}
                                required={true}
                            >
                                {children}
                            </Component>
                        </>

                    )}
                </FormGroup>
            </FormControl>
        </>
    )
}

export default Filter